import './PaymentPage.scss';

import React from 'react';

const PaymentPage = () => {
  return <div className="PaymentPage">PaymentPage under construction</div>;
};

export default PaymentPage;
